import type { DiscoveryItem, DiscoveryEntityType } from '@/mocks/discoverySocial';
import { typeLabels, typeIcons, typeColors, getTrendingByType } from '@/mocks/discoverySocial';
import DiscoveryCard from './DiscoveryCard';

interface DiscoveryCategorySectionProps {
  type: DiscoveryEntityType;
  items: DiscoveryItem[];
}

export default function DiscoveryCategorySection({ type, items }: DiscoveryCategorySectionProps) {
  const colors = typeColors[type];
  const label = typeLabels[type];
  const icon = typeIcons[type];

  if (items.length === 0) return null;

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="flex items-center gap-3 mb-8">
          <div className={`w-10 h-10 rounded-xl ${colors.bg} flex items-center justify-center`}>
            <i className={`${icon} text-lg ${colors.text}`}></i>
          </div>
          <div>
            <h2 className="text-lg md:text-xl font-extrabold text-foreground-950">{label} en Tendencia</h2>
            <p className="text-xs text-foreground-500 mt-0.5">
              {items.length} {items.length === 1 ? 'destacado' : 'destacados'} con mayor crecimiento
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {items.map((item) => (
            <DiscoveryCard key={`${type}-${item.id}`} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}